import React, { useState } from "react";
import person1 from "../../assets/svg/person1.svg";
import person2 from "../../assets/svg/person2.svg";
import person3 from "../../assets/svg/person3.svg";
import quoteOpen from "../../assets/svg/quoteOpen.svg";
import quoteClose from "../../assets/svg/quoteClose.svg";

const items = [
  {
    desc: "We reduced payment errors and gained full visibility over our expenses.",
    img: person1,
    name: "Sarah Mwangi",
    department: "Finance Manager at Syntel Africa",
  },
  {
    desc: "I can now pay staff and track expenses from anywhere, no spreadsheets.",
    img: person2,
    name: "James Mburu",
    department: "Business Owner at Syntel Africa",
  },
  {
    desc: "Our cash flow is predictable and our payments are always on time.",
    img: person3,
    name: "Peter Otieno",
    department: "Operations Manager",
  },
  {
    desc: "Ndovu Pay has streamlined our payroll and supplier payments completely.",
    img: person1,
    name: "Grace Wanjiru",
    department: "CFO at Nairobi Logistics",
  },
  {
    desc: "Managing petty cash used to be a nightmare. Now it's effortless.",
    img: person2,
    name: "David Kamau",
    department: "SME Owner",
  },
];

const VISIBLE = 3;

function Testimonial() {
  const [start, setStart] = useState(0);

  const canPrev = start > 0;
  const canNext = start + VISIBLE < items.length;

  const visible = items.slice(start, start + VISIBLE);

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="flex flex-col">
        <div className="flex items-center gap-[.5rem]">
          <span className="w-[1.375rem] h-[0.125rem] rounded-[1.875rem] bg-[#DB2A12] flex-shrink-0" />
          <span className="text-[#DB2A12] font-lexend text-[1.125rem] font-[500] leading-[1.25rem] tracking-[0.1125rem] uppercase">
            Testimonials
          </span>
        </div>
        <div className="mt-[1rem] text-[#1E191B] font-lexend text-[2.25rem] font-[600] leading-[2.625rem] tracking-[-0.0405rem]">
          Trusted by Businesses Across Kenya
        </div>
      </div>

      {/* Nav buttons row */}
      <div className="mt-[2.5rem] flex items-center justify-end gap-[.75rem]">
        <button
          onClick={() => setStart((s) => s - 1)}
          disabled={!canPrev}
          className={`w-[3rem] h-[3rem] rounded-full flex items-center justify-center border transition-all duration-200 ${canPrev ? "border-[#DB2A12] text-[#DB2A12] hover:bg-[#DB2A12] hover:text-white" : "border-[#EFF0F6] text-[#C0BBC8] cursor-not-allowed"}`}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M16 10H4M10 16l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <button
          onClick={() => setStart((s) => s + 1)}
          disabled={!canNext}
          className={`w-[3rem] h-[3rem] rounded-full flex items-center justify-center transition-all duration-200 ${canNext ? "text-white" : "border border-[#EFF0F6] text-[#C0BBC8] cursor-not-allowed"}`}
          style={canNext ? { background: "linear-gradient(180deg, #FFB600 -50.53%, #C30B14 173.16%)" } : {}}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4 10h12M10 4l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* Cards */}
      <div className="mt-[1.5rem]">
        <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[1.5rem]">
          {visible.map((item, i) => (
            <div
              key={i}
              className="rounded-[1.25rem] border border-[#EFF0F6] bg-white shadow-[0_5px_14px_0_rgba(8,15,52,0.04)] p-[1.5rem] flex flex-col"
            >
              {/* Open quote */}
              <img src={quoteOpen} alt="quote" className="w-[1.75rem]" />

              {/* Desc */}
              <div className="mt-[1rem] text-[#000] text-center font-inter text-[1.125rem] font-[300] italic leading-[164.5%] max-w-[20rem] mx-auto">
                {item.desc}
              </div>

              {/* Close quote */}
              <div className="flex justify-end mt-[1rem]">
                <img src={quoteClose} alt="quote" className="w-[1.75rem]" />
              </div>

              {/* Person */}
              <div className="mt-auto pt-[1.5rem] flex items-center gap-[.75rem]">
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-[3rem] h-[3rem] rounded-full object-cover flex-shrink-0"
                />
                <div className="flex flex-col">
                  <span className="text-[#000] font-['DM_Sans'] text-[1.125rem] font-[700] leading-[1.25rem]">
                    {item.name}
                  </span>
                  <span className="text-[#6F6C90] font-['DM_Sans'] text-[1.125rem] font-[400] leading-[1.25rem]">
                    {item.department}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Footer line */}
      <div className="mt-[2.5rem] flex flex-col sm:flex-row sm:items-center gap-[.75rem]">
        <div className="flex -space-x-[.8rem] flex-shrink-0">
          {[person1, person2, person3]?.map((img, i) => (
            <img key={i} src={img} alt="user" className="w-[2rem] h-[2rem] sm:w-[2.5rem] sm:h-[2.5rem] rounded-full object-cover border-2 border-white" />
          ))}
        </div>
        <span className="text-[#323232] font-lexend text-[1rem] sm:text-[1.25rem] font-[400] leading-[1.5rem] sm:leading-[2.625rem] tracking-[-0.027rem]">
          Join businesses already using Ndovu Pay to manage thousands of transactions daily.
        </span>
      </div>
    </div>
  );
}

export default Testimonial;
